export default "__VITE_ASSET__NOFYmUJf__"